import request from "../axios/axios";
// 错误上报接口
export const errorupdate = (params: any) => {
    return request.post("/stats/erp", params)
}
/** 
 * get请求模板
*/
export const getdemo = () => {
    return request.post("/use", 1, { num: 12 })
}
/** 
 * post请求模板
*/
export const postdemo = () => {
    return request.post("/index")
}
/** 
 * 获取侧边栏游戏分类列表
*/
export const getcategories_list = () => {
    return request.post("/category")
}
/** 
 * 获取到游戏分类详情
*/
export const getcategories_details = (params: any) => {
    return request.post("/category/getGames", params)
}
/** 
 * 验证码获取
*/
export const get_ems = (params: any) => {
    return request.post("/ems/send", params)
}
/** 
 * 用户注册
*/
export const useRegister = (params: any) => {
    return request.post("/user/register", params)
}
/** 
 * 用户登录
*/
export const use_logoin = (params: any) => {
    return request.post("/user/login", params)
}
/** 
 * 用户注销
*/
export const use_deAccount = (params: any) => {
    return request.post("/user/deleteAccount", params)
}
/** 
 * 退出登录
*/
export const use_logout = (params: any) => {
    return request.post("/user/logout", params)
}

/** 
 * 自动登录
*/
export const use_authorize = (params: any) => {
    return request.post("/user/authorize", params)
}
// /user/autologin
/** 
 * 第三方登录
*/
export const use_autologin = (params: any) => {
    return request.post("/user/autologin", params)
}
/** 
 * 修改密码登录
*/
export const use_resetpwd = (params: any) => {
    return request.post("/user/resetpwd", params)
}

/** 
 * 修改个人信息
*/
export const use_profile = (params: any) => {
    return request.post("/user/profile", params)
}

/** 
 * 上传头像
*/
export const use_attachment = (params: any) => {
    return request.post("user/attachment", params, { ablen: 1 })
}
/** 
 * 获取好友列表
*/
export const use_friend = (params: any) => {
    return request.post("/friend", params)
}
/** 
 * 收到好友请求列表
*/
export const use_received = (params: any) => {
    return request.post("/friend/received", params)
}
/** 
 * 发送请求列表
*/
export const use_sent = (params: any) => {
    return request.post("/friend/sent", params)
}
/** 
 * 消息确认
*/
export const use_confirm = (params: any) => {
    return request.post("/friend/confirm", params)
}
/** 
 * 收藏列表
*/
export const use_favorite = (params: any) => {
    return request.post("/my/favorite", params)
}
/** 
 * 添加收藏
*/
export const use_addFavorite = (params: any) => {
    return request.post("/my/addFavorite", params)
}
/** 
 * 删除收藏 可批量删除
*/
export const use_delFavorite = (params: any) => {
    return request.post("/my/delFavorite", params)
}
/** 
 * 游戏历史记录
*/
export const use_recode = (params: any) => {
    return request.post("/my/recode", params)
}
/** 
 * 添加记录
*/
export const use_addRecode = (params: any) => {
    return request.post("/my/addRecode", params)
}
/** 
 * 获取游戏详情
*/
export const getgame_Details = (params: any) => {
    return request.post("/game", params)
}
/** 
 * 文字搜索
*/
export const get_getSeachWord = (params: any) => {
    return request.post("/search/getSeachWord", params)
}
/** 
 * 字段模糊搜索
*/
export const get_getSeach = (params: any) => {
    return request.post("/search", params)
}
/** 
 * 消息列表
*/
export const get_message = (params: any) => {
    return request.post("/message", params)
}
/** 
 * 消息已读
*/
export const get_read = (params: any) => {
    return request.post("/message/read", params)
}

/** 
 * 反馈类型
*/
export const get_feedbackType = (params: any) => {
    return request.post("/game/feedbackType", params)
}
/** 
 * 合作类型
*/
export const get_cooperationType = (params: any) => {
    return request.post("/game/cooperationType", params)
}
/** 
 * 游戏反馈
*/
export const get_feedback = (params: any) => {
    return request.post("/game/feedback", params)
}
/** 
 * 合作反馈
*/
export const get_business = (params: any) => {
    return request.post("/game/businessCooperation", params)
}
/**
 * 获取 new游戏列表
 */
export const get_newgame = (params: any) => {
    return request.post("/game/new", params)
}
/**
 * 获取 hot游戏列表
 */
export const get_hotgame = (params: any) => {
    return request.post("/game/hot", params)
}
/**
 * 获取 rank游戏列表
 */
export const get_rankgame = (params: any) => {
    return request.post("/game/rank", params)
}
/**
 * 5星评分
 */
export const get_rating = (params: any) => {
    return request.post("/vote/rating", params)
}
/**
 * 点赞
 */
export const get_upvote = (params: any) => {
    return request.post("/vote/upvote", params)
}
/**
 * 点踩
 */
export const get_downvote = (params: any) => {
    return request.post("/vote/downvote", params)
}